export const dateFormat = 'DD/MM/YYYY';
export const dateFormatSmall = 'DD/MM/YY';
export const simpleDateTimeFormat = 'YYYY-MM-DD HH:mm';
export const apiDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ';
export const apiJustDateFormat = 'YYYY-MM-DD';
export const timeFormat = 'HH:mm';